export default function SearchInput({ 
  placeholder = "Search...", 
  value, 
  onChange, 
  className = "",
  ...props 
}) {
  return (
    <div className={`relative ${className}`}>
      <div className="min-h-8 px-2 py-1.5 bg-white rounded-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] border border-black inline-flex justify-start items-center gap-1.5 overflow-hidden odin-focus-within">
        <div className="flex-1 flex justify-start items-center gap-1.5">
          <svg 
            className="w-4 h-4 text-neutral-400" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
            />
          </svg>
          <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className="flex-1 bg-transparent border-none outline-none text-sm font-normal font-['Geist'] leading-tight tracking-tight text-neutral-900 placeholder:text-neutral-500"
            {...props}
          />
        </div>
        {value && (
          <button
            onClick={() => onChange({ target: { value: '' } })}
            className="w-4 h-4 text-neutral-400 hover:text-neutral-600 transition-colors"
            type="button"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}